<script setup lang="ts">
    // @ts-ignore
    import { computed, defineAsyncComponent, onBeforeUnmount, onMounted, onUnmounted, ref } from 'vue';
    import i18n from '@/localization/i18n';
    import { Carousel, Slide} from 'vue3-carousel'

    const Star = defineAsyncComponent(() => import('vue-material-design-icons/Star.vue'))
    
    let activeSlide  = ref(0)
    let slideItemsPerPage  = ref(3)
    const slideItemsNumber = 4

    const checkScreenSize = () => {
        if (window.innerWidth <= 600) {
            slideItemsPerPage.value = 1
        } else if (window.innerWidth >= 600 && window.innerWidth <= 992) {
            slideItemsPerPage.value = 2
        } else if (window.innerWidth > 992) {
            slideItemsPerPage.value = 3
        }
    }

    // const totalPages = computed(() => Math.ceil(slideItemsNumber / slideItemsPerPage.value));
    // const currentPage = computed(() => Math.floor(activeSlide.value / slideItemsPerPage.value) + 1);

    // const changePage = (page:number) => {
    //     activeSlide.value = (page - 1) * slideItemsPerPage.value;
    // };

    // const VITE_ASSET_URL = import.meta.env.VITE_ASSET_URL

    // Local variables
    const t = i18n.global.t
    // const screenSize = ref(0)

    onMounted(() => {
        checkScreenSize()
    })
</script>

<template>
    <section class="py-5" style="background-color:#233648;">
  <div class="container">

    <!-- Titre -->
    <div class="text-center mb-5">
      <h2 class="fw-semibold text-white">
        {{ t('w_txt_psHome_testimonials_title') }}
      </h2>
    </div>

    <!-- Steps -->
    <div class="row g-4 justify-content-center mt-5">

      <!-- Step 1 -->
      <div class="col-md-4">
        <div class="position-relative h-100 bg-light rounded-4 p-4 text-center">

          <span
            class="bg-info position-absolute top-0 start-50 translate-middle badge rounded-circle step-badge"
            >
            1
          </span>

          <h5 class="fw-semibold mt-4 pt-3">
           {{ t('w_txt_psHome_create_account') }}
          </h5>

          <p class="text-muted mt-3 mb-0">
           {{ t('w_txt_psHome_create_account_legend') }}
          </p>
        </div>
      </div>

      <!-- Step 2 -->
      <div class="col-md-4">
        <div class="position-relative h-100 bg-light rounded-4 p-4 text-center">

          <span
            class="bg-info position-absolute top-0 start-50 translate-middle badge rounded-circle step-badge"
            >
            2
          </span>

          <h5 class="fw-semibold mt-4 pt-3">
            {{ t('w_txt_psHome_customize_your_account') }}
          </h5>

          <p class="text-muted mt-3 mb-0">
            {{ t('w_txt_psHome_customize_your_account_legend') }}
          </p>
        </div>
      </div>

      <!-- Step 3 -->
      <div class="col-md-4">
        <div class="position-relative h-100 bg-light rounded-4 p-4 text-center ">

          <span
            class=" bg-info position-absolute top-0 start-50 translate-middle badge rounded-circle step-badge"
            >
            3
          </span>

          <h5 class="fw-semibold mt-4 pt-3">
            {{ t('w_txt_psHome_follow_up') }}
          </h5>

          <p class="text-muted mt-3 mb-0">
            {{ t('w_txt_psHome_follow_up_legend') }}
          </p>
        </div>
      </div>

    </div>

    <!-- CTA -->
    <div class="text-center mt-5">
      <a
        class="btn btn-info rounded px-5 py-3 fw-semibold text-white"
        style="background-color:#2FA8D6; font-size:18px;" href="/ps/home/?next=singupScreenRoute" target="_blank"
        
      >
        {{ t('w_txt_psHome_create_pro_account') }}
    </a>
    </div>

  </div>
</section>

</template>

<style scoped>
@import url('@/assets/css/bootstrap-extended.css');
@import url('@/assets/css/main.css');

.custom-carousel{
  padding: 0px;
}
.custom-pagination {
  display: flex;
  justify-content: center;
}

.pagination-dot {
  margin: 0 5px;
  color: gray; /* Default color for inactive slides */
}

.pagination-dot.active {
  color: black; /* Blue color for active slide */
}
.step-badge {
  width: 80px;
  height: 80px;
  font-size: 50px;
  line-height: 80px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  display: flex;
  justify-content: center;
  align-items: center;
  

}
</style>